import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

class SectionWithIcon extends Component {
  render() {
    const {
      children,
      last,
      icon,
      label,
      iconBackgroundColor,
      sectionId,
    } = this.props
    const baseClassName = "composer-section-with-icon"
    const className = classnames({
      [baseClassName]: true,
      [`${baseClassName}-last`]: last,
    })

    const iconClassName = classnames({
      [`${baseClassName}-icon`]: true,
      [`${baseClassName}-icon--with-background`]: iconBackgroundColor != null,
    })

    const iconStyle = iconBackgroundColor && {
      backgroundColor: iconBackgroundColor,
    }

    return (
      <div className={className} id={sectionId}>
        <div className={`${baseClassName}-sidebar`}>
          <div className={iconClassName} style={iconStyle}>
            {label && (
              <span className={`${baseClassName}-label`} data-label={label} />
            )}
            {icon && <span>{icon}</span>}
          </div>
        </div>
        {children}
      </div>
    )
  }
}

SectionWithIcon.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.node,
  iconBackgroundColor: PropTypes.string,
  last: PropTypes.bool,
  label: PropTypes.string,
  sectionId: PropTypes.string,
}

SectionWithIcon.defaultProps = {
  last: false,
}

export default SectionWithIcon
